
import axios from '@/libs/axios'
export class   ExportDataServices{


  static async exportData(request) {
    const d=new Date();
    let cdate=d.getFullYear() + "-" +
      ("00" + (d.getMonth() + 1)).slice(-2) + "-" +
      ("00" + d.getDate()).slice(-2) + " " +
      ("00" + d.getHours()).slice(-2) + ":" +
      ("00" + d.getMinutes()).slice(-2) + ":" +
      ("00" + d.getSeconds()).slice(-2)
  let exportType=request.exportType;

  return new Promise((resolve,reject) => {

    axios.get(`export`,{params: request,responseType: 'blob'})
      .then(response => {
       resolve({success:true})
  const type = response.headers['content-type']
  const blob = new Blob([response.data], { type: type, encoding: 'UTF-8' })
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = 'file'+cdate+'.'+exportType
  link.click()
      })
      .catch(reason =>{

        reject(reason.response)

      })
  })
}





    static async exportReport(request) {
      const d=new Date();
      let cdate=d.getFullYear() + "-" +
        ("00" + (d.getMonth() + 1)).slice(-2) + "-" +
        ("00" + d.getDate()).slice(-2) + " " +
        ("00" + d.getHours()).slice(-2) + ":" +
        ("00" + d.getMinutes()).slice(-2) + ":" +
        ("00" + d.getSeconds()).slice(-2)
    let exportType=request.exporter;


    return new Promise((resolve,reject) => {
    // Object.assign(request,{responseType: 'blob'})
      axios.post(`export`,
      request,
        {responseType: 'blob'},

      )
        .then(response => {
         resolve({success:true})
    const type = response.headers['content-type']
    const blob = new Blob([response.data], { type: type, encoding: 'UTF-8' })
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = 'file'+cdate+'.'+exportType
    link.click()
        })
        .catch(reason =>{

          reject(reason.response)

        })
    })
  }
 static async printReport(request) {
        const d=new Date();
        let cdate=d.getFullYear() + "-" +
          ("00" + (d.getMonth() + 1)).slice(-2) + "-" +
          ("00" + d.getDate()).slice(-2) + " " +
          ("00" + d.getHours()).slice(-2) + ":" +
          ("00" + d.getMinutes()).slice(-2) + ":" +
          ("00" + d.getSeconds()).slice(-2)
      let exportType=request.exportType;

      return new Promise((resolve,reject) => {

        axios.post(`export`,
        request,
          {responseType: 'blob'},

        )
          .then(response => {
           resolve({success:true})
           const blob = new Blob([response.data], { type: 'application/pdf', encoding: 'UTF-8' })

           var blobURL = URL.createObjectURL(blob);

             let  iframe =  document.createElement('iframe'); //load content in an iframe to print later
               document.body.appendChild(iframe);

               iframe.style.display = 'none';
               iframe.src = blobURL;
               iframe.onload = function() {
                 setTimeout(function() {
                   iframe.focus();
                   iframe.contentWindow.print();
                 }, 1);
               };
          })
          .catch(reason =>{

            reject(reason.response)

          })
      })
    }


static async exportReportold(request) {
  const d=new Date();
  let cdate=d.getFullYear() + "-" +
    ("00" + (d.getMonth() + 1)).slice(-2) + "-" +
    ("00" + d.getDate()).slice(-2) + " " +
    ("00" + d.getHours()).slice(-2) + ":" +
    ("00" + d.getMinutes()).slice(-2) + ":" +
    ("00" + d.getSeconds()).slice(-2)
let exportType=request.exporter;


return new Promise((resolve,reject) => {
// Object.assign(request,{responseType: 'blob'})
  axios.get(`export`,
  { params: request ,responseType: 'blob'},


  )
    .then(response => {
     resolve({success:true})
const type = response.headers['content-type']
const blob = new Blob([response.data], { type: type, encoding: 'UTF-8' })
const link = document.createElement('a')
link.href = window.URL.createObjectURL(blob)
link.download = 'file'+cdate+'.'+exportType
link.click()
    })
    .catch(reason =>{

      reject(reason.response)

    })
})
}



}
